export const postOrionLogout = () => {
  return new Promise((resolve) => setTimeout(resolve, 10));
};
